import React, { Component, useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import VisibilitySensor from "react-visibility-sensor";
import NxaFAQCall from "../NxaFAQCall";
import CTAButtons from "../ReuasbleComponets/CTAButtons";
import TrustedCompanies from "../ReuasbleComponets/TrustedCompanies";
import LeadmagnetCall from "../ReuasbleComponets/leadmagenetcall";
import PricingCardsCall from "../PricingCardsCall";

const features = [
  {
    id: 1,
    icon: "./../assets/images/new_call_page/callrings.svg",
    title: "Smart Call Routing",
    description: "Direct calls to the right department, employee, or location.",
  },
  {
    id: 2,
    icon: "./../assets/images/new_call_page/callrings.svg",
    title: "Automated Scheduling",
    description: "Set up call handling for holidays, time zones, and breaks.",
  },
  {
    id: 3,
    icon: "./../assets/images/new_call_page/callrings.svg",
    title: "Uninterrupted Availability",
    description:
      " Keep your business running even during downtime or emergencies.",
  },
];

export const VideoAutoPlay = () => {
  const videoRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (isVisible) {
      videoRef.current.play();
    } else {
      if (videoRef.current.play) {
        videoRef.current.pause();
      }
    }
  }, [isVisible]);

  return (
    <VisibilitySensor onChange={(isVisible) => setIsVisible(isVisible)}>
      <video width="100%" height="100%" muted controls loop ref={videoRef}>
        <source
          src="./../assets/videos/nxatel-manage-calls.mp4"
          type="video/mp4"
        />
      </video>
    </VisibilitySensor>
  );
};

class Call extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    return (
      <>
        {/* Call Banner (Upgrade your business phone system to a cloud PBX.​) Section*/}
        <section className="call-hero">
          <div className="call-content">
            <h1>
              Get Secure, Compliant Business Numbers & Never Miss an Opportunity
            </h1>
            <p>
              Instantly set up international, toll-free, and local numbers on
              NxaTel. Collaborate better with note-taking, call tagging, and
              scheduling callbacks.
            </p>
            <div className="call-button">
              <CTAButtons />
            </div>
          </div>

          <div className="call-image">
            <img
              className="call"
              src="./../assets/images/new_call_page/mainban.webp"
              alt="Video Call"
              loading="lazy"
            />
          </div>
        </section>
        {/*  The complete communication system for growing your business. Section​ */}
        <section className="power_up">
          <h1>Power Up Your Business Calls with NxaTel</h1>
          <p>
            Get the right tools to stay connected, never miss an opportunity,
            and collaborate seamlessly.
          </p>
          <div className="call-power">
            <div className="power-image">
              <img
                className="keypad"
                src="./../assets\images\new_call_page\ladycalling.webp"
                alt="Lady on a Call"
                loading="lazy"
              />
            </div>
            <div className="power-content">
              <h2>Instant Business Numbers</h2>
              <p>
                <span>24/7 Business Presence</span>
                <br />
                Stay available anytime with auto-attendant and call scheduling.
              </p>
              <p>
                <span> Smarter Call Collaboration</span>
                <br /> Assign, tag, and take notes on calls for seamless
                teamwork.
              </p>
              <p>
                <span> Virtual Receptionist</span> <br />
                Tailor your IVR system to route calls efficiently.
              </p>

              <div className="call-button">
                <div className="d-flex  gap--15 mt--15">
                  <Link
                    to="/demo"
                    className="btn bg--transparent text--orange border--2 border--orange sf--t-medium radius--16-0 pt--15
                    "
                  >
                    Get your Demo
                  </Link>
                  <Link
                    to="/signup"
                    className="btn bg--orange text--white border--2 border--orange sf--t-medium radius--16-0"
                  >
                    Claim Your Business
                    <br /> Number Instantly
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Video Section :Manage calls, voicemails, call recording and business*/}
        <section className="virtual-rep">
          <h1>Virtual Receptionist – Your AI-Driven Call Assistant</h1>
          <p>
            Instantly set up your virtual receptionist and tailor your
            Interactive Voice Response (IVR) system to your needs.
          </p>
          <div className="virtual-rep-container">
            <div className="virtual-video">
              <div className="video-box">
                <VideoAutoPlay />
              </div>
            </div>
            <div className="virtual-content">
              <div className="feature-list">
                {features.map((feature) => (
                  <div className="feature-item" key={feature.id}>
                    <img
                      src={feature.icon}
                      alt={feature.title}
                      className="feature-icon"
                    />
                    <p>
                      <strong>{feature.title}</strong> – {feature.description}
                    </p>
                  </div>
                ))}
                <div className="call-button">
                  <CTAButtons />
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Build teams Section  */}
        <div className="work-together">
          <div className="work-together__container">
            <h2 className="work-together__title">Built for your teams</h2>
            <p className="work-together__subtitle">
              Stay connected and productive with everything in one place—no
              <br /> more juggling multiple apps.
            </p>

            <div className="work-together__cards">
              {/* Card 1 */}
              <div className="work-together__card">
                <div className="work-together__card-header">For Startups</div>
                <div className="work-together__card-image">
                  <img
                    src="./../assets/images/new_call_page/mobile.webp"
                    alt="Mobile App"
                    loading="lazy"
                    width={200}
                  />
                </div>
                <Link to="/signup" className="work-together__card-link">
                  <span className="work-together__card-link-text">
                    Download and
                    <br /> Try for Free
                  </span>
                  <img
                    src="./../assets/images/right-arrow-dwn.svg"
                    alt="Right Arrow"
                    className="work-together__card-link-icon"
                  />
                </Link>
              </div>

              {/* Card 2 */}
              <div className="work-together__card">
                <div className="work-together__card-header">
                  For Teams &amp; Managers
                </div>
                <div className="work-together__card-image">
                  <img
                    src="./../assets/images/new_call_page/laptop.webp"
                    alt="Laptop"
                    loading="lazy"
                    width={280}
                  />
                </div>
                <Link to="/demo" className="work-together__card-link">
                  <span className="work-together__card-link-text">
                    Get your Demo
                    <br /> See Nxatel in action
                  </span>
                  <img
                    src="./../assets/images/right-arrow-dwn.svg"
                    alt="Right Arrow"
                    loading="lazy"
                    className="work-together__card-link-icon"
                  />
                </Link>
              </div>

              {/* Card 3 */}
              <div className="work-together__card">
                <div className="work-together__card-header">For Hybrid</div>
                <div className="work-together__card-image">
                  <img
                    src="./../assets/images/new_call_page/device.webp"
                    alt="Device"
                    loading="lazy"
                    width={270}
                  />
                </div>
                <Link to="#" className="work-together__card-link">
                  <span className="work-together__card-link-text">
                    Explore our Devices
                  </span>
                  <img
                    src="./../assets/images/right-arrow-dwn.svg"
                    alt="Right Arrow"
                    loading="lazy"
                    className="work-together__card-link-icon"
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>
        {/* Trusted companies */}
        <TrustedCompanies />
        {/* Why Choose NxaTel */}
        <section className="why-choose-call">
          <h2 className="why-choose-call__title">Why Choose Nxatel?</h2>
          <div className="why-choose-call__grid">
            {/* Card 1 */}
            <div className="why-choose-call__card">
              <div className="why-choose-call__icon-container">
                <img
                  src="./../assets/images/wn-1.svg"
                  alt="Instant Set-Up"
                  className="why-choose-call__icon"
                />
              </div>
              <h3 className="why-choose-call__feature-title">Instant Set-Up</h3>
              <p className="why-choose-call__feature-description">
                Activate in just 3 minutes, no hardware required.
              </p>
            </div>

            {/* Card 2 */}
            <div className="why-choose-call__card">
              <div className="why-choose-call__icon-container">
                <img
                  src="./../assets/images/wn-2.svg"
                  alt="Scattered Tools"
                  className="why-choose-call__icon"
                />
              </div>
              <h3 className="why-choose-call__feature-title">
                Scattered Tools
              </h3>
              <p className="why-choose-call__feature-description">
                All calls, messages, and voicemails in one easy platform.
              </p>
            </div>

            {/* Card 3 */}
            <div className="why-choose-call__card">
              <div className="why-choose-call__icon-container">
                <img
                  src="./../assets/images/wn-3.svg"
                  alt="Missed Opportunities"
                  className="why-choose-call__icon"
                />
              </div>
              <h3 className="why-choose-call__feature-title">
                Missed Opportunities
              </h3>
              <p className="why-choose-call__feature-description">
                Never lose a client with auto-attendants and call scheduling.
              </p>
            </div>
          </div>
        </section>
        {/* Pricing Model */}
        <section className="Call-Plan">
          <h1>Flexible Plans for Every Business</h1>
          <p className="call-plan-subheading">
            Find the perfect plan that fits your needs—
            <span className="call-plan-span">no hidden fees</span>, no long-term
            contracts.
          </p>
          <PricingCardsCall />
        </section>

        {/* FAQ */}
        <NxaFAQCall />
        {/* LeadMagnet */}
        {/* <LeadmagnetCall /> */}
        {/* Try for Free Section */}
        <section className="call-start-free">
          <div className="call-start-image">
            <img
              className="call-free"
              src="./../assets/images/new_call_page/ladytryfree.webp"
              alt="Lady Taking a Call"
              loading="lazy"
            />
          </div>
          <div className="start-free__content">
            <h1>Start Your Free Trial – No Credit Card Needed</h1>
            <p>
              Plans start at R159 per user/per month No long-term contracts. No
              hidden fees. No nonsense.
            </p>
            <div className="call-button">
              <CTAButtons />
            </div>
          </div>
        </section>
      </>
    );
  }
}

export default Call;
